
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quizzes/[quizName]/arena",
      function () {
        return require("private-next-pages/quizzes/[quizName]/arena.tsx");
      }
    ]);
  